module.exports = __webpack_public_path__ + "img/venndiagram.50a177e0.png";